const stringComparator = (a: string, b: string) => {

    const initalMatch = a.toLowerCase()
    const nextMatch = b.toLowerCase()

    if (initalMatch < nextMatch) {
        return -1;
    }
    if (initalMatch > nextMatch) {
        return 1;
    }
    return 0;
}

export default stringComparator